import styled from 'styled-components';

import { Box, BoxProps } from '../Box';
import { getColor, theme } from '../theme';
import { createShouldForwardProp } from '../utils';

type StyleProps = {
  elevation?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
} & BoxProps;

const getElevationStyles = ({ elevation }: StyleProps) => {
  switch (elevation) {
    case 0:
      return `box-shadow: ${theme.boxShadow({ level: 0 })}`;
    case 1:
      return `box-shadow: ${theme.boxShadow({ level: 1 })}`;
    case 2:
      return `box-shadow: ${theme.boxShadow({ level: 2 })}`;
    case 3:
      return `box-shadow: ${theme.boxShadow({ level: 3 })}`;
    case 4:
      return `box-shadow: ${theme.boxShadow({ level: 4 })}`;
    case 5:
      return `box-shadow: ${theme.boxShadow({ level: 5 })}`;
    case 6:
      return `box-shadow: ${theme.boxShadow({ level: 6 })}`;
    default:
      return 'border: 0';
  }
};

export const Paper = styled(Box).withConfig<StyleProps>({
  shouldForwardProp: createShouldForwardProp('elevation'),
})`
  background: ${getColor('background')};
  border-radius: 4px;
  border: 1px solid ${getColor('neutral', 2)};
  ${getElevationStyles};
`;
